import { APPLICATION_SYNC_STATUS, type TApplicationSyncStatusType } from '@fingerprinting/types'

import type { IClientBadgeProps } from '@fingerprinting/features/client/common/client-badge'

export function getChildren(status?: TApplicationSyncStatusType): string {
  switch (status) {
    case APPLICATION_SYNC_STATUS.NOT_SYNCED:
      return 'Not synced'
    case APPLICATION_SYNC_STATUS.SYNCING:
      return 'Syncing'
    case APPLICATION_SYNC_STATUS.ERROR:
      return 'Error'
    case APPLICATION_SYNC_STATUS.SYNCED:
      return 'Synced'
    default:
      return 'Unknown'
  }
}

export function getColor(status?: TApplicationSyncStatusType): IClientBadgeProps['color'] {
  switch (status) {
    case APPLICATION_SYNC_STATUS.NOT_SYNCED:
      return 'primary-950'
    case APPLICATION_SYNC_STATUS.SYNCING:
      return 'warning'
    case APPLICATION_SYNC_STATUS.ERROR:
      return 'error'
    case APPLICATION_SYNC_STATUS.SYNCED:
      return 'success'
    default:
      return 'primary-500'
  }
}
